module.exports = __webpack_public_path__ + "img/down.ec1d5305.svg";